<template>
  <div class="time-ruler">
    <div
        v-for="hour in hours"
        :key="hour"
        class="time-slot "
        :class="{
        passed: isPassed(hour),
        current: isCurrent(hour),
        future: isFuture(hour)
      } "

        @click="handleSlotClick(hour)"
    >
      <div class="time-label">{{ hour }}:00</div>
      <div class="time-indicator"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeRuler',
  props: {
    selectedDate: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      now: new Date(),
      index:'' , // 高亮选中状态
    };
  },

  computed: {
    today() {
      return new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
    },
    selectedDateDay() {
      return new Date(
          this.selectedDate.getFullYear(),
          this.selectedDate.getMonth(),
          this.selectedDate.getDate()
      );
    },
    dateStatus() {
      const todayTime = this.today.getTime();
      const selectedTime = this.selectedDateDay.getTime();
      if (selectedTime < todayTime) return 'past';
      if (selectedTime === todayTime) return 'today';
      return 'future';
    },
    hours() {
      const result = [];
      for (let i = 0; i < 24; i++) {
        result.push(i);
      }
      return result;
    }
  },
  methods: {
    isPassed(hour) {
      if (this.dateStatus === 'past') return true;
      if (this.dateStatus === 'today') {
        return hour < this.now.getHours();
      }
      return false;
    },
    isCurrent(hour) {
      return this.dateStatus === 'today' && hour === this.now.getHours();
    },
    isFuture(hour) {
      if (this.dateStatus === 'future') return true;
      if (this.dateStatus === 'today') {
        return hour > this.now.getHours();
      }
      return false;
    },
    handleSlotClick(hour) {
      this.index = hour
      // 仅允许点击过去时间段
      if (this.isCurrent(hour) || this.isPassed(hour)) {
        this.$emit('time-slot-click', hour);
      }
    }
  },
  created() {
    console.log(this.selectedDate,11111111111);
  }
};
</script>

<style scoped>
.time-ruler {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 60px;
  background: rgba(19, 25, 47, 0.9);
  border-radius: 8px;
  padding: 0 10px;
  font-family: Arial, sans-serif;
}

.time-slot {
  flex: 1;
  text-align: center;
  position: relative;
  padding-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.time-slot.future {
  opacity: 0.6;
  cursor: not-allowed;
}

.time-label {
  font-size:12px;
  color: #fff;
  margin-bottom: 5px;
}

.time-indicator {
  width: 2px;
  height: 15px;
  margin: 0 auto;
  background: #ccc;
  transition: all 0.3s ease;
}

/* 已过时间段 */
.time-slot.passed .time-indicator {
  background: #e0e0e0;
  height: 10px;

}

/* 当前时间段 */
.time-slot.current .time-indicator {
  background: #1a73e8;
  height: 20px;
  box-shadow: 0 0 8px rgba(23, 24, 25, 1);
  font-size: 16px;
}

/* 未来时间段 */
.time-slot.future .time-indicator {
  background: #34a853;
  height: 10px;
}

/* 点击反馈 */
.time-slot.future:hover .time-indicator {
  transform: scale(1.2);
}
</style>
